import { render, staticRenderFns } from "./FooterArea.vue?vue&type=template&id=4ed869de&scoped=true&"
import script from "./FooterArea.vue?vue&type=script&lang=js&"
export * from "./FooterArea.vue?vue&type=script&lang=js&"
import style0 from "./FooterArea.vue?vue&type=style&index=0&id=4ed869de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed869de",
  null
  
)

export default component.exports